<script>
import InputWebsiteVue from "../../components/shared/InputWebsite.vue";

const CHAT_PREVIEW_PADDING = 15;
const CHAT_PREVIEW_WIDTH = 400;
const DEFAULT_PRIMARY_COLOR = "#4764d5";
const DEFAULT_TEXT_COLOR = "#4F4F4F";
const IMAGES_ENDPOINT = process.env.VUE_APP_IMAGES

export default {
  components: { InputWebsiteVue },
  name: "ChatBotPreview",
  props: {
    botSettings: {
      type: Object,
    },
    formType: String,
    previewToggle: Function,
    previewShow: Boolean,
    actions: {
      type: Array,
      default: () => [
        "Set-up Guidance",
        "Report a bug",
        "Feature request",
        "Latest release",
        "Feedback",
      ],
    },
  },
  methods: {

    checkIsHexColor(hexColorString) {
      const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
      return hexColorRegex.test(hexColorString);
    },
    sendAnalyticsEvent() {
      gtag('event', 'create_bot_custom_demo_widget_click', {});
      amplitude.getInstance().logEvent('create_bot_custom_demo_widget_click', {});
    }
  },
  computed: {
    userStyles() {
        return {
            maxWidth: this.userIcon ? '75%' : '80%'
        }
    },
    botStyles() {
        return {
            background: this.primaryColor,
            maxWidth: this.agentIcon ? '75%' : '80%'
        }
    },
    botName() {
      const newName = this.botSettings.name;
      return newName ? newName : "Ai bot";
    },

    welcomeMessage() {
      const message = this.botSettings.welcomeMessage;
      return message ? message : "Hello! How can I help you?";
    },

    inputPlaceholder() {
      const placeholder = this.botSettings.placeholder;
      return placeholder ? placeholder : "Ask me anything";
    },

    previewWidth() {
      return CHAT_PREVIEW_WIDTH + CHAT_PREVIEW_PADDING * 2;
    },

    previewStyles() {
      return {
        padding: `${CHAT_PREVIEW_PADDING}px`,
        width: `${this.previewWidth}px`,
        maxWidth: '80vw'
      };
    },

    chatbotBoxWidth() {
      return `${CHAT_PREVIEW_WIDTH}px`;
    },

    chatHeight() {
      const hight = this.botSettings.chatHight;
      return hight >= 550 && hight <= 700 ? `${hight}px` : "550px";
    },

    chatFontSize() {
      const fontSize = this.botSettings.fontSize;

      if (fontSize < 12) {
        return "12px";
      } else if (fontSize > 30) {
        return "30px";
      } else {
        return `${fontSize}px`;
      }
    },

    chatbotBoxStyle() {
      return {
        height: this.chatHeight,
        maxHeight: '80vh',
        width: this.chatbotBoxWidth,
        maxWidth: `calc(80vw - 30px)`,
        fontSize: this.chatFontSize,
      };
    },

    botIconStyle() {
      const position = this.botSettings.iconPosition;
      const fromBottom = this.botSettings.iconFromBottomDistance;
      const horizontalDistance = this.botSettings.iconHorizontalDistance;
      const buttonIcon = this.botSettings.botIconPreview;
      const horizontalPosition = () => {
        
        return position === "BL"
          ? {
              left: horizontalDistance > 300 ? '300px' : horizontalDistance < 0 ? '0px' : `${horizontalDistance}px`,
            }
          : { 
              right: horizontalDistance > 300 ? '300px' : horizontalDistance < 0 ? '0px' : `${horizontalDistance}px` 
            };
      };

      return {
        position: "fixed",
        bottom: fromBottom > 300 ? '300px' : fromBottom < 0 ? '0px' : `${fromBottom}px`,
        ...horizontalPosition(),
        background: buttonIcon || this.botSettings.botIcon && this.botSettings.botIcon !== 'null' ? "transparent" : this.primaryColor,
      };
    },

    botIconBoxStyle() {
      const iconSize = this.botSettings.iconSize;

      return {
        height: iconSize ? `${iconSize}px` : "48px",
        width: iconSize ? `${iconSize}px` : "48px",
      };
    },

    thumbUpUrl() {
      return require("@/assets/icons/ThumbUp.svg");
    },

    sendUrl() {
      return require("@/assets/icons/sendIcon.svg");
    },

    botIcon() {
      const imagePreview = this.botSettings.botIconPreview;
      
      return imagePreview ? imagePreview : typeof(this.botSettings.botIcon) === 'string' && this.botSettings.botIcon.length > 0 && this.botSettings.botIcon !== 'null' ? IMAGES_ENDPOINT + this.botSettings.botIcon : require("@/assets/icons/ai-icon.svg");
    },

    agentIcon() {
      const imagePreview = this.botSettings.agentIconPreview;
      return imagePreview ? imagePreview : typeof(this.botSettings.agentIcon) === 'string' && this.botSettings.agentIcon.length > 0 && this.botSettings.agentIcon !== 'null' ? IMAGES_ENDPOINT + this.botSettings.agentIcon : null;
    },

    userIcon() {
      const imagePreview = this.botSettings.userIconPreview;
      return imagePreview ? imagePreview : typeof(this.botSettings.userIcon) === 'string' && this.botSettings.userIcon.length > 0 && this.botSettings.userIcon !== 'null' ? IMAGES_ENDPOINT + this.botSettings.userIcon : null;
    },

    hideFeedback() {
      const result = this.botSettings.hideFeedbackButton;
      return result;
    },

    hideToolTip() {
      const result = this.botSettings.hideToolTip;
      return result;
    },

    primaryColor() {
      const primaryColor = this.botSettings.primaryColor;

      return this.checkIsHexColor(primaryColor)
        ? primaryColor
        : this.formType === 'create' ? DEFAULT_PRIMARY_COLOR : this.botSettings.primaryColor;
    },

    textColor() {
      const textColor = this.botSettings.textColor;

      return this.checkIsHexColor(textColor) ? textColor : this.formType === 'create' ? DEFAULT_TEXT_COLOR : this.botSettings.textColor;
    },
  },
  data() {
    return {
      inputMessage: "",
    };
  },
};
</script>

<template>
  <div class="box">
    <div class="chatbot_preview__box" :style="previewStyles">
      
      <div class="title_wrapper" @click="previewToggle">
        <p class="chatbot_preview__preview-title">
          <svg class="preview-title_icon" :class="{preview_shown: previewShow}">
            <use href="../../assets/icons/arrow-down.svg#arrow-down"></use>
          </svg>
          <span class="preview-title">Preview</span>
        </p>
      </div>
      <div class="chatbot_preview" :style="chatbotBoxStyle">
        <div
          class="chatbot_preview__heder"
          :style="{ background: primaryColor }"
        >
          <div class="chatbot_preview__title-box">
            <div v-if="agentIcon" class="chatbot_preview__bot-icon-box">
              <img :src="agentIcon" alt="" />
            </div>
            <div>
              <p class="chatbot_preview__title">{{ this.botName }}</p>
              <p class="chatbot_preview__sub-title">Ai Assistant</p>
            </div>
          </div>
          <!-- <div v-if="!hideFeedback" class="chatbot_preview__thumbUp-box">
            <button class="chatbot_preview__thumbUp">
              <svg class="chatbot_preview__feedbackIcon">
                <use xlink:href="@/assets/icons/ThumbUp.svg#ThumbUp"></use>
              </svg>
            </button>
            <button
              class="chatbot_preview__thumbUp chatbot_preview__thumbUp--rotate180"
            >
              <svg class="chatbot_preview__feedbackIcon">
                <use xlink:href="@/assets/icons/ThumbUp.svg#ThumbUp"></use>
              </svg>
            </button>
          </div> -->
        </div>

        <div class="chatbot_preview__chat">
          <div class="chatbot_preview__messages-box">
            <div>
              <div class="chatbot_preview__bot-wrapper">
                <div v-if="agentIcon" class="chatbot_preview__chat-icon">
                    <img :src="agentIcon" alt="" />
                  </div>
                <div
                  class="chatbot_preview__bot-message"
                  :style="botStyles"
                >
                  <p
                    class="chatbot_preview__message-text"
                  >
                    {{ this.welcomeMessage }}
                  </p>
                  <p class="chatbot_preview__time chatbot_preview__time--left">
                    1:58 PM
                  </p>
                </div>
              </div>
            </div>

            <div>
              <!-- <div class="chatbot_preview__username-wrapper">
                <p
                  class="chatbot_preview__username"
                  :style="{ color: textColor }"
                >
                  Andri Thomas
                </p>
              </div> -->

              <div class="chatbot_preview__user-wrapper">
                <div class="chatbot_preview__user-message" :style="userStyles">
                  <p
                    class="chatbot_preview__message-text"
                    :style="{color: this.textColor}"
                  >
                    Ok, Thanks for your reply.
                  </p>
                  <p class="chatbot_preview__time">
                    1:59 PM
                  </p>
                </div>
                <div v-if="userIcon" class="chatbot_preview__chat-icon">
                  <img :src="userIcon" alt="" />
                </div>
              </div>
            </div>
          </div>

          <!-- <div v-if="!hideToolTip" class="chatbot_preview__action-box">
            <button
              v-for="action of actions"
              class="chatbot_preview__action"
              :style="{ color: primaryColor, borderColor: primaryColor }"
            >
              {{ action }}
            </button>
          </div> -->
        </div>

        <div class="chatbot_preview__footer">
          <input
            type="text"
            :placeholder="inputPlaceholder"
            :value="inputMessage"
            :style="{ color: textColor }"
            class="chatbot_preview__input"
          />
          <button
            class="chatbot_preview__send-btn"
            :style="{ background: primaryColor }"
          >
            <div class="chatbot_preview__send-icon-box">
              <img :src="sendUrl" alt="" />
            </div>
          </button>
        </div>
      </div>
    </div>

    <button class="chatbot_preview__bot-icon-button" :style="botIconStyle">
      <div :style="botIconBoxStyle">
        <img @click="sendAnalyticsEvent" :src="botIcon" alt="" />
      </div>
    </button>
  </div>
</template>

<style scoped lang="scss">
.box {
  height: 100%;
}

.chatbot_preview__box {
  /* z-index: 996; */
  border: 1px solid #e3e8ef;
  background: #f8f9fa;
  position: sticky;
  top: 0px;
  border-radius: 6px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;

  /* @media (max-height: 800px) {

  } */
}

.title_wrapper {
  position: absolute;
  top: 15px;
  left: 0;
  transform: translate(-99%);
  border: 1px solid #e3e8ef;
  border-right: none;
  background: #f8f9fa;
  padding: 5px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;

  @media (min-width: 1120px) {
    display: none;
  }

  @media (max-width: 559px) {
    padding: 10px 5px;
  }
}

.chatbot_preview__preview-title {
  font-family: inherit;
  color: #4f4f4f;
  font-size: 16px;
  font-style: normal;
  /* font-weight: 700; */
  line-height: 24px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
}

.preview-title_icon {
  width: 14px;
  height: 8px;
  stroke:#4764d5;
  transform: rotate(90deg);
  margin-right: 5px;
  transition: all 150ms linear;

  &.preview_shown {
    transform: rotate(270deg);
  }

  @media (min-width: 1120px) {
    display: none;
  }
}

.preview-title {
  @media (max-width: 560px) {
    display: none;
  }
}

.chatbot_preview__bot-icon-button {
  padding: 0;
  z-index: 999;
  font: inherit;
  color: inherit;
  background: transparent;
  text-align: center;
  border-radius: 50%;
  border: none;
  transition: all ease-in-out 300ms;
  cursor: default;
  /* display: flex;
  align-items: center;
  justify-content: center; */
  /* overflow: hidden; */

  & > div {
    object-fit: cover;
    position: relative;

    & > img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}

.chatbot_preview__title {
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
  padding: 0;
  max-width: 222px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chatbot_preview__sub-title {
  color: #e0e0e0;
  font-size: 0.8em;
  font-weight: 400;
  line-height: 1.142;
  margin: 0;
  padding: 0;
}

.chatbot_preview {
  border-radius: 8px;
  border: 1px solid #e7e7e7;
  background: #fff;
  overflow: hidden;
  object-fit: cover;
  display: flex;
  flex-direction: column;

  @media (max-height: 800px) {
    max-height: 70vh !important;
  }
}

.chatbot_preview__heder {
  padding: 20px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 1px 19px 0px rgba(0, 0, 0, 0.42);
  -webkit-box-shadow: 0px 1px 19px 0px rgba(0, 0, 0, 0.42);
  -moz-box-shadow: 0px 1px 19px 0px rgba(0, 0, 0, 0.42);
}

.chatbot_preview__title-box {
  display: flex;
  gap: 20px;
}

.chatbot_preview__thumbUp-box {
  display: flex;
  gap: 25px;
}

.chatbot_preview__bot-icon-box {
  overflow: hidden;
  border-radius: 50%;
  object-fit: cover;
  height: 50px;
  width: 50px;
  position: relative;

  & img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.chatbot_preview__thumbUp {
  object-fit: cover;
  padding: 0;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  fill: #fff;

  & svg {
    width: 16px;
    height: 16px;
    fill: inherit;
  }

  &--rotate180 {
    & svg {
      transform: rotate(180deg);
    }
  }
}

.chatbot_preview__chat {
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.chatbot_preview__messages-box {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.chatbot_preview__chat-icon {
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  object-fit: cover;
  min-width: 24px;
  max-width: 24px;
  height: 24px;

  & img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.chatbot_preview__bot-wrapper {
  display: flex;
  gap: 5px;
}

.chatbot_preview__bot-message {
  font-family: 'Inter', sans-serif;
  margin: 0;
  padding: 10px 15px;
  border-radius: 0px 16px 16px 16px;
  color: #fff;
  font-weight: 400;
  line-height: 1.5;
  margin-right: auto;
}

.chatbot_preview__user-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
}

.chatbot_preview__user-message {
  font-family: 'Inter', sans-serif;
  margin: 0;
  padding: 10px 15px;
  border-radius: 16px 0px 16px 16px;
  background-color: #e6edff;
  color: #4f4f4f;
  font-size: 1em;
  font-weight: 400;
  line-height: 1.5;
}

.chatbot_preview__message-text {
  font-family: inherit;
  padding: 0;
  margin: 0;
  font-size: 1em;
  font-weight: 400;
  line-height: 1.5;
  max-width: 100%;
  /* display: block; */
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.chatbot_preview__time {
  font-family: inherit;
    display: block;
    margin-top: 3px;
    padding: 0;
    color: #4f4f4f;
    text-align: right;
    font-size: 0.7em;
    font-weight: 400;
    line-height: 1.33;
    text-align: right;
    opacity: 0.6;

    &--left {
        color: #fff;
    }
}

.chatbot_preview__username-wrapper {
  width: fit-content;
  margin-left: auto;
}

.chatbot_preview__username {
  display: block;
  margin: 0;
  padding: 0;
  color: #4f4f4f;
  font-size: 0.78em;
  font-weight: 500;
  line-height: 1.428;
  margin-bottom: 5px;
}

.chatbot_preview__action-box {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 24px;
}

.chatbot_preview__action {
  padding: 4px 8px;
  font: inherit;
  color: inherit;
  background-color: transparent;
  cursor: pointer;
  text-align: center;
  font-size: 0.78em;
  font-weight: 500;
  line-height: 1.71;
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  display: inline-block;
  transition: all ease-in-out 300ms;
}

.chatbot_preview__footer {
  border-top: 1px solid #e7e7e7;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.19);
  -webkit-box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.19);
}

.chatbot_preview__send-btn {
  font: inherit;
  color: inherit;
  background: #3056d3;
  cursor: pointer;
  color: #fff;
  fill: #fff;
  text-align: center;
  border-radius: 6px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ease-in-out 300ms;
  width: 52px;
  height: 52px;

  &:hover {
    background: #2448c0;
    color: #fff;
  }
}

.chatbot_preview__input {
  width: 80%;
  height: 52px;
  border-radius: 6px;
  border: 1px solid #e7e7e7;
  background: #f4f7ff;
  padding: 14px 20px;
}

.chatbot_preview__send-icon-box {
  object-fit: cover;
  width: 24px;
  height: 24px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 100%;
    height: 100%;
  }
}
</style>
